export default {
  heading: {
    id: 'checkout_bouygues_magic_link_layout_generic_error_heading',
    defaultMessage: `{status}
C’est l’heure de se mettre au vert.`,
  },
  firstParagraph: {
    id: 'checkout_bouygues_magic_link_layout_generic_error_first_paragraph',
    defaultMessage:
      'Si vous êtes là, c’est que l’URL est incorrecte ou que la page n’existe plus. Cliquez directement sur le lien que vous avez reçu par e-mail ou par SMS pour accéder à votre offre.',
  },
  secondParagraph: {
    id: 'checkout_bouygues_magic_link_layout_generic_error_second_paragraph',
    defaultMessage:
      'Ou alors… c’est peut-être un signe : il est temps de faire une pause et d’aller toucher un peu d’herbe. Mais pas celle-ci, hein. De la vraie, dehors.',
  },
}
